// Generated EntityRelationships
import { type EntityRelationship } from '../../scripts/libs/typesLib';
import * as schema from './MainSchema';

export const entityRelationships: Record<string, EntityRelationship> = {
    Contractors: {
        name: 'Contractors',
        table: schema.Contractors,
        schemaName: 'AppDB',
        tableName: 'Contractors',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Job',
                relationType: 'oneToOne',
                childTable: schema.Jobs,
                currentTableKey: 'JobID',
                childKey: 'ID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
            {
                name: 'TeamHandsSubcontractors',
                relationType: 'oneToMany',
                childTable: schema.TeamHandsSubcontractors,
                currentTableKey: 'ID',
                childKey: 'SubcontractorID'
            },
            {
                name: 'UsersASContractor',
                relationType: 'oneToMany',
                childTable: schema.Users,
                currentTableKey: 'ID',
                childKey: 'ContractorID'
            },
            {
                name: 'Teams',
                relationType: 'oneToMany',
                childTable: schema.Teams,
                currentTableKey: 'ID',
                childKey: 'ContractorID'
            },
        ],
        primaryKey: 'ID'
    },
    ImportLog: {
        name: 'ImportLog',
        table: schema.ImportLog,
        schemaName: 'AppDB',
        tableName: 'ImportLog',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'ImportUser',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ImportUserID',
                childKey: 'ID'
            },
            {
                name: 'Job',
                relationType: 'oneToOne',
                childTable: schema.Jobs,
                currentTableKey: 'JobID',
                childKey: 'ID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
            {
                name: 'Status',
                relationType: 'oneToOne',
                childTable: schema.Ref_ImportStatuses,
                currentTableKey: 'StatusID',
                childKey: 'ID'
            },
            {
                name: 'UploadUser',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'UploadUserID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Jobs: {
        name: 'Jobs',
        table: schema.Jobs,
        schemaName: 'AppDB',
        tableName: 'Jobs',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Contractors',
                relationType: 'oneToMany',
                childTable: schema.Contractors,
                currentTableKey: 'ID',
                childKey: 'JobID'
            },
            {
                name: 'ImportLog',
                relationType: 'oneToMany',
                childTable: schema.ImportLog,
                currentTableKey: 'ID',
                childKey: 'JobID'
            },
            {
                name: 'PG',
                relationType: 'oneToOne',
                childTable: schema.PGs,
                currentTableKey: 'PGID',
                childKey: 'ID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
            {
                name: 'UserJobs',
                relationType: 'oneToMany',
                childTable: schema.UserJobs,
                currentTableKey: 'ID',
                childKey: 'JobID'
            },
            {
                name: 'UsersASDefaultJob',
                relationType: 'oneToMany',
                childTable: schema.Users,
                currentTableKey: 'ID',
                childKey: 'DefaultJobID'
            },
            {
                name: 'Teams',
                relationType: 'oneToMany',
                childTable: schema.Teams,
                currentTableKey: 'ID',
                childKey: 'PrimaryJobID'
            },
        ],
        primaryKey: 'ID'
    },
    Log_ClientErrors: {
        name: 'Log_ClientErrors',
        table: schema.Log_ClientErrors,
        schemaName: 'AppDB',
        tableName: 'Log_ClientErrors',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: true,
        relations: [
        ],
        primaryKey: 'ID'
    },
    Log_EventExecution: {
        name: 'Log_EventExecution',
        table: schema.Log_EventExecution,
        schemaName: 'AppDB',
        tableName: 'Log_EventExecution',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
        ],
        primaryKey: 'ID'
    },
    Ref_AccountReqStatuses: {
        name: 'Ref_AccountReqStatuses',
        table: schema.Ref_AccountReqStatuses,
        schemaName: 'AppDB',
        tableName: 'Ref_AccountReqStatuses',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'UserAccountReqs',
                relationType: 'oneToMany',
                childTable: schema.UserAccountReqs,
                currentTableKey: 'ID',
                childKey: 'ReqStatusID'
            },
        ],
        primaryKey: 'ID'
    },
    Ref_Crafts: {
        name: 'Ref_Crafts',
        table: schema.Ref_Crafts,
        schemaName: 'AppDB',
        tableName: 'Ref_Crafts',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Ref_Disciplines',
                relationType: 'oneToMany',
                childTable: schema.Ref_Disciplines,
                currentTableKey: 'ID',
                childKey: 'CraftID'
            },
            {
                name: 'Users',
                relationType: 'oneToMany',
                childTable: schema.Users,
                currentTableKey: 'ID',
                childKey: 'CraftID'
            },
            {
                name: 'Teams',
                relationType: 'oneToMany',
                childTable: schema.Teams,
                currentTableKey: 'ID',
                childKey: 'CraftID'
            },
        ],
        primaryKey: 'ID'
    },
    Ref_Disciplines: {
        name: 'Ref_Disciplines',
        table: schema.Ref_Disciplines,
        schemaName: 'AppDB',
        tableName: 'Ref_Disciplines',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Craft',
                relationType: 'oneToOne',
                childTable: schema.Ref_Crafts,
                currentTableKey: 'CraftID',
                childKey: 'ID'
            },
            {
                name: 'UserDisciplines',
                relationType: 'oneToMany',
                childTable: schema.UserDisciplines,
                currentTableKey: 'ID',
                childKey: 'DisciplineID'
            },
        ],
        primaryKey: 'ID'
    },
    Ref_ImportStatuses: {
        name: 'Ref_ImportStatuses',
        table: schema.Ref_ImportStatuses,
        schemaName: 'AppDB',
        tableName: 'Ref_ImportStatuses',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'ImportLog',
                relationType: 'oneToMany',
                childTable: schema.ImportLog,
                currentTableKey: 'ID',
                childKey: 'StatusID'
            },
        ],
        primaryKey: 'ID'
    },
    Ref_Methods: {
        name: 'Ref_Methods',
        table: schema.Ref_Methods,
        schemaName: 'AppDB',
        tableName: 'Ref_Methods',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Method',
                relationType: 'oneToOne',
                childTable: schema.Whitelist_TableMethodRoles,
                currentTableKey: 'ID',
                childKey: 'MethodID'
            },
        ],
        primaryKey: 'ID'
    },
    Ref_Prog_ActivityRejections: {
        name: 'Ref_Prog_ActivityRejections',
        table: schema.Ref_Prog_ActivityRejections,
        schemaName: 'AppDB',
        tableName: 'Ref_Prog_ActivityRejections',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
        ],
        primaryKey: 'ID'
    },
    Ref_Prog_ActivityStatuses: {
        name: 'Ref_Prog_ActivityStatuses',
        table: schema.Ref_Prog_ActivityStatuses,
        schemaName: 'AppDB',
        tableName: 'Ref_Prog_ActivityStatuses',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
        ],
        primaryKey: 'ID'
    },
    Ref_Prog_Ques: {
        name: 'Ref_Prog_Ques',
        table: schema.Ref_Prog_Ques,
        schemaName: 'AppDB',
        tableName: 'Ref_Prog_Ques',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
        ],
        primaryKey: 'ID'
    },
    Ref_Prog_ReportGroups: {
        name: 'Ref_Prog_ReportGroups',
        table: schema.Ref_Prog_ReportGroups,
        schemaName: 'AppDB',
        tableName: 'Ref_Prog_ReportGroups',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
        ],
        primaryKey: 'ID'
    },
    Ref_Roles: {
        name: 'Ref_Roles',
        table: schema.Ref_Roles,
        schemaName: 'AppDB',
        tableName: 'Ref_Roles',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'UserRoles',
                relationType: 'oneToMany',
                childTable: schema.UserRoles,
                currentTableKey: 'ID',
                childKey: 'RoleID'
            },
            {
                name: 'Role',
                relationType: 'oneToOne',
                childTable: schema.Whitelist_TableMethodRoles,
                currentTableKey: 'ID',
                childKey: 'RoleID'
            },
        ],
        primaryKey: 'ID'
    },
    Ref_Shifts: {
        name: 'Ref_Shifts',
        table: schema.Ref_Shifts,
        schemaName: 'AppDB',
        tableName: 'Ref_Shifts',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Teams',
                relationType: 'oneToMany',
                childTable: schema.Teams,
                currentTableKey: 'ID',
                childKey: 'ShiftID'
            },
        ],
        primaryKey: 'ID'
    },
    Ref_TS_AllocationTypes: {
        name: 'Ref_TS_AllocationTypes',
        table: schema.Ref_TS_AllocationTypes,
        schemaName: 'AppDB',
        tableName: 'Ref_TS_AllocationTypes',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
        ],
        primaryKey: 'ID'
    },
    Ref_TS_Statuses: {
        name: 'Ref_TS_Statuses',
        table: schema.Ref_TS_Statuses,
        schemaName: 'AppDB',
        tableName: 'Ref_TS_Statuses',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
        ],
        primaryKey: 'ID'
    },
    Sessions: {
        name: 'Sessions',
        table: schema.Sessions,
        schemaName: 'AppDB',
        tableName: 'Sessions',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: true,
        relations: [
            {
                name: 'User',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'UserID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    SettingsGlobal: {
        name: 'SettingsGlobal',
        table: schema.SettingsGlobal,
        schemaName: 'AppDB',
        tableName: 'SettingsGlobal',
        kind: 'table',
        primaryKeys: [{ name: 'Label', dataType: 'string' }],
        hasUserID: false,
        relations: [
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
        ],
        primaryKey: 'Label'
    },
    SettingsUser: {
        name: 'SettingsUser',
        table: schema.SettingsUser,
        schemaName: 'AppDB',
        tableName: 'SettingsUser',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: true,
        relations: [
            {
                name: 'User',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'UserID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Signatures: {
        name: 'Signatures',
        table: schema.Signatures,
        schemaName: 'AppDB',
        tableName: 'Signatures',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
            {
                name: 'UsersASSignature',
                relationType: 'oneToMany',
                childTable: schema.Users,
                currentTableKey: 'ID',
                childKey: 'SignatureID'
            },
        ],
        primaryKey: 'ID'
    },
    TeamHands: {
        name: 'TeamHands',
        table: schema.TeamHands,
        schemaName: 'AppDB',
        tableName: 'TeamHands',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Team',
                relationType: 'oneToOne',
                childTable: schema.Teams,
                currentTableKey: 'TeamID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    TeamHandsREV: {
        name: 'TeamHandsREV',
        table: schema.TeamHandsREV,
        schemaName: 'AppDB',
        tableName: 'TeamHandsREV',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
        ],
        primaryKey: 'ID'
    },
    TeamHandsSubcontractors: {
        name: 'TeamHandsSubcontractors',
        table: schema.TeamHandsSubcontractors,
        schemaName: 'AppDB',
        tableName: 'TeamHandsSubcontractors',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Subcontractor',
                relationType: 'oneToOne',
                childTable: schema.Contractors,
                currentTableKey: 'SubcontractorID',
                childKey: 'ID'
            },
            {
                name: 'Team',
                relationType: 'oneToOne',
                childTable: schema.Teams,
                currentTableKey: 'TeamID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    TeamHandsSubcontractorsREV: {
        name: 'TeamHandsSubcontractorsREV',
        table: schema.TeamHandsSubcontractorsREV,
        schemaName: 'AppDB',
        tableName: 'TeamHandsSubcontractorsREV',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
        ],
        primaryKey: 'ID'
    },
    UserAccountReqs: {
        name: 'UserAccountReqs',
        table: schema.UserAccountReqs,
        schemaName: 'AppDB',
        tableName: 'UserAccountReqs',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'ReqStatus',
                relationType: 'oneToOne',
                childTable: schema.Ref_AccountReqStatuses,
                currentTableKey: 'ReqStatusID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    UserAPIKeys: {
        name: 'UserAPIKeys',
        table: schema.UserAPIKeys,
        schemaName: 'AppDB',
        tableName: 'UserAPIKeys',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: true,
        relations: [
            {
                name: 'User',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'UserID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    UserCreds: {
        name: 'UserCreds',
        table: schema.UserCreds,
        schemaName: 'AppDB',
        tableName: 'UserCreds',
        kind: 'table',
        primaryKeys: [{ name: 'UserID', dataType: 'number' }],
        hasUserID: true,
        relations: [
            {
                name: 'Users',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'UserID',
                childKey: 'ID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
        ],
        primaryKey: 'UserID'
    },
    UserDisciplines: {
        name: 'UserDisciplines',
        table: schema.UserDisciplines,
        schemaName: 'AppDB',
        tableName: 'UserDisciplines',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: true,
        relations: [
            {
                name: 'Discipline',
                relationType: 'oneToOne',
                childTable: schema.Ref_Disciplines,
                currentTableKey: 'DisciplineID',
                childKey: 'ID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
            {
                name: 'User',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'UserID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    UserJobs: {
        name: 'UserJobs',
        table: schema.UserJobs,
        schemaName: 'AppDB',
        tableName: 'UserJobs',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: true,
        relations: [
            {
                name: 'Job',
                relationType: 'oneToOne',
                childTable: schema.Jobs,
                currentTableKey: 'JobID',
                childKey: 'ID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
            {
                name: 'User',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'UserID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    UserRoles: {
        name: 'UserRoles',
        table: schema.UserRoles,
        schemaName: 'AppDB',
        tableName: 'UserRoles',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: true,
        relations: [
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
            {
                name: 'Role',
                relationType: 'oneToOne',
                childTable: schema.Ref_Roles,
                currentTableKey: 'RoleID',
                childKey: 'ID'
            },
            {
                name: 'User',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'UserID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Whitelist_APIKeyTables: {
        name: 'Whitelist_APIKeyTables',
        table: schema.Whitelist_APIKeyTables,
        schemaName: 'AppDB',
        tableName: 'Whitelist_APIKeyTables',
        kind: 'table',
        primaryKeys: [{ name: 'Table', dataType: 'string' }, { name: 'Schema', dataType: 'string' }],
        hasUserID: false,
        relations: [
        ],
        primaryKey: 'Table'
    },
    Whitelist_TableMethodRoles: {
        name: 'Whitelist_TableMethodRoles',
        table: schema.Whitelist_TableMethodRoles,
        schemaName: 'AppDB',
        tableName: 'Whitelist_TableMethodRoles',
        kind: 'table',
        primaryKeys: [{ name: 'Schema', dataType: 'string' }, { name: 'Table', dataType: 'string' }, { name: 'MethodID', dataType: 'number' }, { name: 'RoleID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Ref_Methods',
                relationType: 'oneToOne',
                childTable: schema.Ref_Methods,
                currentTableKey: 'MethodID',
                childKey: 'ID'
            },
            {
                name: 'Ref_Roles',
                relationType: 'oneToOne',
                childTable: schema.Ref_Roles,
                currentTableKey: 'RoleID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'Schema'
    },
    Users: {
        name: 'Users',
        table: schema.Users,
        schemaName: 'AppDB',
        tableName: 'Users',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Contractor',
                relationType: 'oneToOne',
                childTable: schema.Contractors,
                currentTableKey: 'ContractorID',
                childKey: 'ID'
            },
            {
                name: 'Craft',
                relationType: 'oneToOne',
                childTable: schema.Ref_Crafts,
                currentTableKey: 'CraftID',
                childKey: 'ID'
            },
            {
                name: 'DefaultJob',
                relationType: 'oneToOne',
                childTable: schema.Jobs,
                currentTableKey: 'DefaultJobID',
                childKey: 'ID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
            {
                name: 'Signature',
                relationType: 'oneToOne',
                childTable: schema.Signatures,
                currentTableKey: 'SignatureID',
                childKey: 'ID'
            },
            {
                name: 'ContractorsASModifiedBy',
                relationType: 'oneToMany',
                childTable: schema.Contractors,
                currentTableKey: 'ID',
                childKey: 'ModifiedBy'
            },
            {
                name: 'ImportLogASUploadUser',
                relationType: 'oneToMany',
                childTable: schema.ImportLog,
                currentTableKey: 'ID',
                childKey: 'UploadUserID'
            },
            {
                name: 'ImportLogASImportUser',
                relationType: 'oneToMany',
                childTable: schema.ImportLog,
                currentTableKey: 'ID',
                childKey: 'ImportUserID'
            },
            {
                name: 'ImportLogASModifiedBy',
                relationType: 'oneToMany',
                childTable: schema.ImportLog,
                currentTableKey: 'ID',
                childKey: 'ModifiedBy'
            },
            {
                name: 'JobsASModifiedBy',
                relationType: 'oneToMany',
                childTable: schema.Jobs,
                currentTableKey: 'ID',
                childKey: 'ModifiedBy'
            },
            {
                name: 'Sessions',
                relationType: 'oneToMany',
                childTable: schema.Sessions,
                currentTableKey: 'ID',
                childKey: 'UserID'
            },
            {
                name: 'SettingsGlobalASModifiedBy',
                relationType: 'oneToMany',
                childTable: schema.SettingsGlobal,
                currentTableKey: 'ID',
                childKey: 'ModifiedBy'
            },
            {
                name: 'SettingsUser',
                relationType: 'oneToMany',
                childTable: schema.SettingsUser,
                currentTableKey: 'ID',
                childKey: 'UserID'
            },
            {
                name: 'SignaturesASModifiedBy',
                relationType: 'oneToMany',
                childTable: schema.Signatures,
                currentTableKey: 'ID',
                childKey: 'ModifiedBy'
            },
            {
                name: 'UserAPIKeys',
                relationType: 'oneToMany',
                childTable: schema.UserAPIKeys,
                currentTableKey: 'ID',
                childKey: 'UserID'
            },
            {
                name: 'UserCreds',
                relationType: 'oneToOne',
                childTable: schema.UserCreds,
                currentTableKey: 'ID',
                childKey: 'UserID'
            },
            {
                name: 'UserCredsASModifiedBy',
                relationType: 'oneToMany',
                childTable: schema.UserCreds,
                currentTableKey: 'ID',
                childKey: 'ModifiedBy'
            },
            {
                name: 'UserDisciplines',
                relationType: 'oneToMany',
                childTable: schema.UserDisciplines,
                currentTableKey: 'ID',
                childKey: 'UserID'
            },
            {
                name: 'UserDisciplinesASModifiedBy',
                relationType: 'oneToMany',
                childTable: schema.UserDisciplines,
                currentTableKey: 'ID',
                childKey: 'ModifiedBy'
            },
            {
                name: 'UserJobs',
                relationType: 'oneToMany',
                childTable: schema.UserJobs,
                currentTableKey: 'ID',
                childKey: 'UserID'
            },
            {
                name: 'UserJobsASModifiedBy',
                relationType: 'oneToMany',
                childTable: schema.UserJobs,
                currentTableKey: 'ID',
                childKey: 'ModifiedBy'
            },
            {
                name: 'UserRoles',
                relationType: 'oneToMany',
                childTable: schema.UserRoles,
                currentTableKey: 'ID',
                childKey: 'UserID'
            },
            {
                name: 'UserRolesASModifiedBy',
                relationType: 'oneToMany',
                childTable: schema.UserRoles,
                currentTableKey: 'ID',
                childKey: 'ModifiedBy'
            },
            {
                name: 'PGsASModifiedBy',
                relationType: 'oneToMany',
                childTable: schema.PGs,
                currentTableKey: 'ID',
                childKey: 'ModifiedBy'
            },
            {
                name: 'TeamsASProjectManager',
                relationType: 'oneToMany',
                childTable: schema.Teams,
                currentTableKey: 'ID',
                childKey: 'ProjectManagerID'
            },
            {
                name: 'TeamsASConstructionManager',
                relationType: 'oneToMany',
                childTable: schema.Teams,
                currentTableKey: 'ID',
                childKey: 'ConstructionManagerID'
            },
            {
                name: 'TeamsASSiteManager',
                relationType: 'oneToMany',
                childTable: schema.Teams,
                currentTableKey: 'ID',
                childKey: 'SiteManagerID'
            },
            {
                name: 'TeamsASAreaManager',
                relationType: 'oneToMany',
                childTable: schema.Teams,
                currentTableKey: 'ID',
                childKey: 'AreaManagerID'
            },
            {
                name: 'TeamsASSuperintendent',
                relationType: 'oneToMany',
                childTable: schema.Teams,
                currentTableKey: 'ID',
                childKey: 'SuperintendentID'
            },
            {
                name: 'TeamsASGeneralForeman',
                relationType: 'oneToMany',
                childTable: schema.Teams,
                currentTableKey: 'ID',
                childKey: 'GeneralForemanID'
            },
            {
                name: 'TeamsASForeman',
                relationType: 'oneToMany',
                childTable: schema.Teams,
                currentTableKey: 'ID',
                childKey: 'ForemanID'
            },
            {
                name: 'TeamsASModifiedBy',
                relationType: 'oneToMany',
                childTable: schema.Teams,
                currentTableKey: 'ID',
                childKey: 'ModifiedBy'
            },
            {
                name: 'UsersASModifiedBy',
                relationType: 'oneToMany',
                childTable: schema.Users,
                currentTableKey: 'ID',
                childKey: 'ModifiedBy'
            },
        ],
        primaryKey: 'ID'
    },
    PGs: {
        name: 'PGs',
        table: schema.PGs,
        schemaName: 'AppDB',
        tableName: 'PGs',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
            {
                name: 'Jobs',
                relationType: 'oneToMany',
                childTable: schema.Jobs,
                currentTableKey: 'ID',
                childKey: 'PGID'
            },
            {
                name: 'Teams',
                relationType: 'oneToMany',
                childTable: schema.Teams,
                currentTableKey: 'ID',
                childKey: 'PGID'
            },
        ],
        primaryKey: 'ID'
    },
    Ref_ImportKeys: {
        name: 'Ref_ImportKeys',
        table: schema.Ref_ImportKeys,
        schemaName: 'AppDB',
        tableName: 'Ref_ImportKeys',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
        ],
        primaryKey: 'ID'
    },
    Ref_Prog_ActivityTypes: {
        name: 'Ref_Prog_ActivityTypes',
        table: schema.Ref_Prog_ActivityTypes,
        schemaName: 'AppDB',
        tableName: 'Ref_Prog_ActivityTypes',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
        ],
        primaryKey: 'ID'
    },
    Teams: {
        name: 'Teams',
        table: schema.Teams,
        schemaName: 'AppDB',
        tableName: 'Teams',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'AreaManager',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'AreaManagerID',
                childKey: 'ID'
            },
            {
                name: 'ConstructionManager',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ConstructionManagerID',
                childKey: 'ID'
            },
            {
                name: 'Contractor',
                relationType: 'oneToOne',
                childTable: schema.Contractors,
                currentTableKey: 'ContractorID',
                childKey: 'ID'
            },
            {
                name: 'Craft',
                relationType: 'oneToOne',
                childTable: schema.Ref_Crafts,
                currentTableKey: 'CraftID',
                childKey: 'ID'
            },
            {
                name: 'Foreman',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ForemanID',
                childKey: 'ID'
            },
            {
                name: 'GeneralForeman',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'GeneralForemanID',
                childKey: 'ID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
            {
                name: 'PG',
                relationType: 'oneToOne',
                childTable: schema.PGs,
                currentTableKey: 'PGID',
                childKey: 'ID'
            },
            {
                name: 'PrimaryJob',
                relationType: 'oneToOne',
                childTable: schema.Jobs,
                currentTableKey: 'PrimaryJobID',
                childKey: 'ID'
            },
            {
                name: 'ProjectManager',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ProjectManagerID',
                childKey: 'ID'
            },
            {
                name: 'Shift',
                relationType: 'oneToOne',
                childTable: schema.Ref_Shifts,
                currentTableKey: 'ShiftID',
                childKey: 'ID'
            },
            {
                name: 'SiteManager',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'SiteManagerID',
                childKey: 'ID'
            },
            {
                name: 'Superintendent',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'SuperintendentID',
                childKey: 'ID'
            },
            {
                name: 'TeamHands',
                relationType: 'oneToMany',
                childTable: schema.TeamHands,
                currentTableKey: 'ID',
                childKey: 'TeamID'
            },
            {
                name: 'TeamHandsSubcontractors',
                relationType: 'oneToMany',
                childTable: schema.TeamHandsSubcontractors,
                currentTableKey: 'ID',
                childKey: 'TeamID'
            },
            {
                name: 'TeamsREV',
                relationType: 'oneToMany',
                childTable: schema.TeamsREV,
                currentTableKey: 'ID',
                childKey: 'OrgID'
            },
        ],
        primaryKey: 'ID'
    },
    TeamsREV: {
        name: 'TeamsREV',
        table: schema.TeamsREV,
        schemaName: 'AppDB',
        tableName: 'TeamsREV',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Org',
                relationType: 'oneToOne',
                childTable: schema.Teams,
                currentTableKey: 'OrgID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    TeamOrgHistory_View: {
        name: 'TeamOrgHistory_View',
        table: schema.TeamOrgHistory_View,
        schemaName: 'AppDB',
        tableName: 'TeamOrgHistory_View',
        kind: 'view',
        primaryKeys: [],
        hasUserID: false,
        relations: [
        ],
        primaryKey: 'TeamID'
    },
    Landing_CostCodes: {
        name: 'Landing_CostCodes',
        table: schema.Landing_CostCodes,
        schemaName: 'PG',
        tableName: 'Landing_CostCodes',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'JobsFROMJobID',
                relationType: 'oneToOne',
                childTable: schema.Jobs,
                currentTableKey: 'JobID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Landing_TSBalance: {
        name: 'Landing_TSBalance',
        table: schema.Landing_TSBalance,
        schemaName: 'PG',
        tableName: 'Landing_TSBalance',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Job',
                relationType: 'oneToOne',
                childTable: schema.Jobs,
                currentTableKey: 'JobID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    MOTD: {
        name: 'MOTD',
        table: schema.MOTD,
        schemaName: 'PG',
        tableName: 'MOTD',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_FAComments: {
        name: 'Prog_FAComments',
        table: schema.Prog_FAComments,
        schemaName: 'PG',
        tableName: 'Prog_FAComments',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Activity',
                relationType: 'oneToOne',
                childTable: schema.Prog_FA,
                currentTableKey: 'ActivityGUID',
                childKey: 'GUID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_FAPipeSpools: {
        name: 'Prog_FAPipeSpools',
        table: schema.Prog_FAPipeSpools,
        schemaName: 'PG',
        tableName: 'Prog_FAPipeSpools',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Activity',
                relationType: 'oneToOne',
                childTable: schema.Prog_FA,
                currentTableKey: 'ActivityGUID',
                childKey: 'GUID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_FAPipeWelds: {
        name: 'Prog_FAPipeWelds',
        table: schema.Prog_FAPipeWelds,
        schemaName: 'PG',
        tableName: 'Prog_FAPipeWelds',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Activity',
                relationType: 'oneToOne',
                childTable: schema.Prog_FA,
                currentTableKey: 'ActivityGUID',
                childKey: 'GUID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_SubmissionDetails: {
        name: 'Prog_SubmissionDetails',
        table: schema.Prog_SubmissionDetails,
        schemaName: 'PG',
        tableName: 'Prog_SubmissionDetails',
        kind: 'table',
        primaryKeys: [{ name: 'GUID', dataType: 'string' }],
        hasUserID: false,
        relations: [
            {
                name: 'Job',
                relationType: 'oneToOne',
                childTable: schema.Jobs,
                currentTableKey: 'JobID',
                childKey: 'ID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
            {
                name: 'Signature',
                relationType: 'oneToOne',
                childTable: schema.Signatures,
                currentTableKey: 'SignatureID',
                childKey: 'ID'
            },
            {
                name: 'SubmittingUser',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'SubmittingUserID',
                childKey: 'ID'
            },
            {
                name: 'Team',
                relationType: 'oneToOne',
                childTable: schema.Teams,
                currentTableKey: 'TeamID',
                childKey: 'ID'
            },
            {
                name: 'Prog_FA',
                relationType: 'oneToMany',
                childTable: schema.Prog_FA,
                currentTableKey: 'GUID',
                childKey: 'SubmissionGUID'
            },
            {
                name: 'Prog_BA',
                relationType: 'oneToMany',
                childTable: schema.Prog_BA,
                currentTableKey: 'GUID',
                childKey: 'SubmissionGUID'
            },
        ],
        primaryKey: 'GUID'
    },
    Prog_SubmissionDetailsREV: {
        name: 'Prog_SubmissionDetailsREV',
        table: schema.Prog_SubmissionDetailsREV,
        schemaName: 'PG',
        tableName: 'Prog_SubmissionDetailsREV',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerSpecsCivil: {
        name: 'Prog_TrackerSpecsCivil',
        table: schema.Prog_TrackerSpecsCivil,
        schemaName: 'PG',
        tableName: 'Prog_TrackerSpecsCivil',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerSpecsCivilREV: {
        name: 'Prog_TrackerSpecsCivilREV',
        table: schema.Prog_TrackerSpecsCivilREV,
        schemaName: 'PG',
        tableName: 'Prog_TrackerSpecsCivilREV',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerSpecsPipe: {
        name: 'Prog_TrackerSpecsPipe',
        table: schema.Prog_TrackerSpecsPipe,
        schemaName: 'PG',
        tableName: 'Prog_TrackerSpecsPipe',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerSpecsPipeREV: {
        name: 'Prog_TrackerSpecsPipeREV',
        table: schema.Prog_TrackerSpecsPipeREV,
        schemaName: 'PG',
        tableName: 'Prog_TrackerSpecsPipeREV',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
        ],
        primaryKey: 'ID'
    },
    SettingsJob: {
        name: 'SettingsJob',
        table: schema.SettingsJob,
        schemaName: 'PG',
        tableName: 'SettingsJob',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Job',
                relationType: 'oneToOne',
                childTable: schema.Jobs,
                currentTableKey: 'JobID',
                childKey: 'ID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    SettingsPG: {
        name: 'SettingsPG',
        table: schema.SettingsPG,
        schemaName: 'PG',
        tableName: 'SettingsPG',
        kind: 'table',
        primaryKeys: [{ name: 'Label', dataType: 'string' }],
        hasUserID: false,
        relations: [
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
        ],
        primaryKey: 'Label'
    },
    TMS_CostCodes: {
        name: 'TMS_CostCodes',
        table: schema.TMS_CostCodes,
        schemaName: 'PG',
        tableName: 'TMS_CostCodes',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'JobsFROMJobID',
                relationType: 'oneToOne',
                childTable: schema.Jobs,
                currentTableKey: 'JobID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    TS_CCGCCs: {
        name: 'TS_CCGCCs',
        table: schema.TS_CCGCCs,
        schemaName: 'PG',
        tableName: 'TS_CCGCCs',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'CCG',
                relationType: 'oneToOne',
                childTable: schema.TS_CCGs,
                currentTableKey: 'CCGID',
                childKey: 'ID'
            },
            {
                name: 'CC',
                relationType: 'oneToOne',
                childTable: schema.TS_CostCodes,
                currentTableKey: 'CCID',
                childKey: 'ID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    TS_CCGs: {
        name: 'TS_CCGs',
        table: schema.TS_CCGs,
        schemaName: 'PG',
        tableName: 'TS_CCGs',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
            {
                name: 'TS_CCGCCs',
                relationType: 'oneToMany',
                childTable: schema.TS_CCGCCs,
                currentTableKey: 'ID',
                childKey: 'CCGID'
            },
            {
                name: 'TS_CCGTeams',
                relationType: 'oneToMany',
                childTable: schema.TS_CCGTeams,
                currentTableKey: 'ID',
                childKey: 'CCGID'
            },
        ],
        primaryKey: 'ID'
    },
    TS_CCGTeams: {
        name: 'TS_CCGTeams',
        table: schema.TS_CCGTeams,
        schemaName: 'PG',
        tableName: 'TS_CCGTeams',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'CCG',
                relationType: 'oneToOne',
                childTable: schema.TS_CCGs,
                currentTableKey: 'CCGID',
                childKey: 'ID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
            {
                name: 'Team',
                relationType: 'oneToOne',
                childTable: schema.Teams,
                currentTableKey: 'TeamID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    TS_CostCodes: {
        name: 'TS_CostCodes',
        table: schema.TS_CostCodes,
        schemaName: 'PG',
        tableName: 'TS_CostCodes',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'AllocationType',
                relationType: 'oneToOne',
                childTable: schema.Ref_TS_AllocationTypes,
                currentTableKey: 'AllocationTypeID',
                childKey: 'ID'
            },
            {
                name: 'JobsFROMJobID',
                relationType: 'oneToOne',
                childTable: schema.Jobs,
                currentTableKey: 'JobID',
                childKey: 'ID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
            {
                name: 'TS_CCGCCs',
                relationType: 'oneToMany',
                childTable: schema.TS_CCGCCs,
                currentTableKey: 'ID',
                childKey: 'CCID'
            },
            {
                name: 'TS_ShiftEntries',
                relationType: 'oneToMany',
                childTable: schema.TS_ShiftEntries,
                currentTableKey: 'ID',
                childKey: 'CCID'
            },
        ],
        primaryKey: 'ID'
    },
    TS_ShiftDetails: {
        name: 'TS_ShiftDetails',
        table: schema.TS_ShiftDetails,
        schemaName: 'PG',
        tableName: 'TS_ShiftDetails',
        kind: 'table',
        primaryKeys: [{ name: 'GUID', dataType: 'string' }],
        hasUserID: false,
        relations: [
            {
                name: 'Job',
                relationType: 'oneToOne',
                childTable: schema.Jobs,
                currentTableKey: 'JobID',
                childKey: 'ID'
            },
            {
                name: 'UsersFROMLocked',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'Locked',
                childKey: 'ID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
            {
                name: 'Status',
                relationType: 'oneToOne',
                childTable: schema.Ref_TS_Statuses,
                currentTableKey: 'StatusID',
                childKey: 'ID'
            },
            {
                name: 'Signature',
                relationType: 'oneToOne',
                childTable: schema.Signatures,
                currentTableKey: 'SignatureID',
                childKey: 'ID'
            },
            {
                name: 'SubmittingUser',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'SubmittingUserID',
                childKey: 'ID'
            },
            {
                name: 'Team',
                relationType: 'oneToOne',
                childTable: schema.Teams,
                currentTableKey: 'TeamID',
                childKey: 'ID'
            },
            {
                name: 'TS_ShiftEmployees',
                relationType: 'oneToMany',
                childTable: schema.TS_ShiftEmployees,
                currentTableKey: 'GUID',
                childKey: 'ShiftGUID'
            },
        ],
        primaryKey: 'GUID'
    },
    TS_ShiftDetailsREV: {
        name: 'TS_ShiftDetailsREV',
        table: schema.TS_ShiftDetailsREV,
        schemaName: 'PG',
        tableName: 'TS_ShiftDetailsREV',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerSpecsTARREV: {
        name: 'Prog_TrackerSpecsTARREV',
        table: schema.Prog_TrackerSpecsTARREV,
        schemaName: 'PG',
        tableName: 'Prog_TrackerSpecsTARREV',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
        ],
        primaryKey: 'ID'
    },
    TS_ShiftEmployeesREV: {
        name: 'TS_ShiftEmployeesREV',
        table: schema.TS_ShiftEmployeesREV,
        schemaName: 'PG',
        tableName: 'TS_ShiftEmployeesREV',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
        ],
        primaryKey: 'ID'
    },
    TS_ShiftEntriesREV: {
        name: 'TS_ShiftEntriesREV',
        table: schema.TS_ShiftEntriesREV,
        schemaName: 'PG',
        tableName: 'TS_ShiftEntriesREV',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
        ],
        primaryKey: 'ID'
    },
    TS_ShiftEmployees: {
        name: 'TS_ShiftEmployees',
        table: schema.TS_ShiftEmployees,
        schemaName: 'PG',
        tableName: 'TS_ShiftEmployees',
        kind: 'table',
        primaryKeys: [{ name: 'GUID', dataType: 'string' }],
        hasUserID: false,
        relations: [
            {
                name: 'Hand',
                relationType: 'oneToOne',
                childTable: schema.TeamHands,
                currentTableKey: 'HandID',
                childKey: 'ID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
            {
                name: 'Shift',
                relationType: 'oneToOne',
                childTable: schema.TS_ShiftDetails,
                currentTableKey: 'ShiftGUID',
                childKey: 'GUID'
            },
            {
                name: 'TS_ShiftEntries',
                relationType: 'oneToMany',
                childTable: schema.TS_ShiftEntries,
                currentTableKey: 'GUID',
                childKey: 'ShiftEmpGUID'
            },
        ],
        primaryKey: 'GUID'
    },
    TS_ShiftEntries: {
        name: 'TS_ShiftEntries',
        table: schema.TS_ShiftEntries,
        schemaName: 'PG',
        tableName: 'TS_ShiftEntries',
        kind: 'table',
        primaryKeys: [{ name: 'GUID', dataType: 'string' }],
        hasUserID: false,
        relations: [
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
            {
                name: 'ShiftEmp',
                relationType: 'oneToOne',
                childTable: schema.TS_ShiftEmployees,
                currentTableKey: 'ShiftEmpGUID',
                childKey: 'GUID'
            },
            {
                name: 'CC',
                relationType: 'oneToOne',
                childTable: schema.TS_CostCodes,
                currentTableKey: 'CCID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'GUID'
    },
    Prog_TrackerSpecsElectCable: {
        name: 'Prog_TrackerSpecsElectCable',
        table: schema.Prog_TrackerSpecsElectCable,
        schemaName: 'PG',
        tableName: 'Prog_TrackerSpecsElectCable',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerSpecsElectCableREV: {
        name: 'Prog_TrackerSpecsElectCableREV',
        table: schema.Prog_TrackerSpecsElectCableREV,
        schemaName: 'PG',
        tableName: 'Prog_TrackerSpecsElectCableREV',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerSpecsElectInst: {
        name: 'Prog_TrackerSpecsElectInst',
        table: schema.Prog_TrackerSpecsElectInst,
        schemaName: 'PG',
        tableName: 'Prog_TrackerSpecsElectInst',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerSpecsElectTray: {
        name: 'Prog_TrackerSpecsElectTray',
        table: schema.Prog_TrackerSpecsElectTray,
        schemaName: 'PG',
        tableName: 'Prog_TrackerSpecsElectTray',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerSpecsElectTrayREV: {
        name: 'Prog_TrackerSpecsElectTrayREV',
        table: schema.Prog_TrackerSpecsElectTrayREV,
        schemaName: 'PG',
        tableName: 'Prog_TrackerSpecsElectTrayREV',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerSpecsElectGeneral: {
        name: 'Prog_TrackerSpecsElectGeneral',
        table: schema.Prog_TrackerSpecsElectGeneral,
        schemaName: 'PG',
        tableName: 'Prog_TrackerSpecsElectGeneral',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerSpecsElectGeneralREV: {
        name: 'Prog_TrackerSpecsElectGeneralREV',
        table: schema.Prog_TrackerSpecsElectGeneralREV,
        schemaName: 'PG',
        tableName: 'Prog_TrackerSpecsElectGeneralREV',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerSpecsElectInstREV: {
        name: 'Prog_TrackerSpecsElectInstREV',
        table: schema.Prog_TrackerSpecsElectInstREV,
        schemaName: 'PG',
        tableName: 'Prog_TrackerSpecsElectInstREV',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerSpecsInsulation: {
        name: 'Prog_TrackerSpecsInsulation',
        table: schema.Prog_TrackerSpecsInsulation,
        schemaName: 'PG',
        tableName: 'Prog_TrackerSpecsInsulation',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerSpecsInsulationREV: {
        name: 'Prog_TrackerSpecsInsulationREV',
        table: schema.Prog_TrackerSpecsInsulationREV,
        schemaName: 'PG',
        tableName: 'Prog_TrackerSpecsInsulationREV',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerSpecsTAR: {
        name: 'Prog_TrackerSpecsTAR',
        table: schema.Prog_TrackerSpecsTAR,
        schemaName: 'PG',
        tableName: 'Prog_TrackerSpecsTAR',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
            {
                name: 'WorkDiscipline',
                relationType: 'oneToOne',
                childTable: schema.Ref_Disciplines,
                currentTableKey: 'WorkDisciplineID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerSpecsElectConduit: {
        name: 'Prog_TrackerSpecsElectConduit',
        table: schema.Prog_TrackerSpecsElectConduit,
        schemaName: 'PG',
        tableName: 'Prog_TrackerSpecsElectConduit',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerSpecsElectConduitREV: {
        name: 'Prog_TrackerSpecsElectConduitREV',
        table: schema.Prog_TrackerSpecsElectConduitREV,
        schemaName: 'PG',
        tableName: 'Prog_TrackerSpecsElectConduitREV',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
        ],
        primaryKey: 'ID'
    },
    Landing_TrackerCivil: {
        name: 'Landing_TrackerCivil',
        table: schema.Landing_TrackerCivil,
        schemaName: 'PG',
        tableName: 'Landing_TrackerCivil',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Job',
                relationType: 'oneToOne',
                childTable: schema.Jobs,
                currentTableKey: 'JobID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Landing_TrackerElectCable: {
        name: 'Landing_TrackerElectCable',
        table: schema.Landing_TrackerElectCable,
        schemaName: 'PG',
        tableName: 'Landing_TrackerElectCable',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Job',
                relationType: 'oneToOne',
                childTable: schema.Jobs,
                currentTableKey: 'JobID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Landing_TrackerElectConduit: {
        name: 'Landing_TrackerElectConduit',
        table: schema.Landing_TrackerElectConduit,
        schemaName: 'PG',
        tableName: 'Landing_TrackerElectConduit',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Job',
                relationType: 'oneToOne',
                childTable: schema.Jobs,
                currentTableKey: 'JobID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Landing_TrackerElectGeneral: {
        name: 'Landing_TrackerElectGeneral',
        table: schema.Landing_TrackerElectGeneral,
        schemaName: 'PG',
        tableName: 'Landing_TrackerElectGeneral',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Job',
                relationType: 'oneToOne',
                childTable: schema.Jobs,
                currentTableKey: 'JobID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Landing_TrackerElectInst: {
        name: 'Landing_TrackerElectInst',
        table: schema.Landing_TrackerElectInst,
        schemaName: 'PG',
        tableName: 'Landing_TrackerElectInst',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Job',
                relationType: 'oneToOne',
                childTable: schema.Jobs,
                currentTableKey: 'JobID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Landing_TrackerElectTray: {
        name: 'Landing_TrackerElectTray',
        table: schema.Landing_TrackerElectTray,
        schemaName: 'PG',
        tableName: 'Landing_TrackerElectTray',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Job',
                relationType: 'oneToOne',
                childTable: schema.Jobs,
                currentTableKey: 'JobID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Landing_TrackerInsulation: {
        name: 'Landing_TrackerInsulation',
        table: schema.Landing_TrackerInsulation,
        schemaName: 'PG',
        tableName: 'Landing_TrackerInsulation',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Job',
                relationType: 'oneToOne',
                childTable: schema.Jobs,
                currentTableKey: 'JobID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Landing_TrackerPipe: {
        name: 'Landing_TrackerPipe',
        table: schema.Landing_TrackerPipe,
        schemaName: 'PG',
        tableName: 'Landing_TrackerPipe',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Job',
                relationType: 'oneToOne',
                childTable: schema.Jobs,
                currentTableKey: 'JobID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Landing_TrackerTAR: {
        name: 'Landing_TrackerTAR',
        table: schema.Landing_TrackerTAR,
        schemaName: 'PG',
        tableName: 'Landing_TrackerTAR',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Job',
                relationType: 'oneToOne',
                childTable: schema.Jobs,
                currentTableKey: 'JobID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_FAREV: {
        name: 'Prog_FAREV',
        table: schema.Prog_FAREV,
        schemaName: 'PG',
        tableName: 'Prog_FAREV',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerMetaREV: {
        name: 'Prog_TrackerMetaREV',
        table: schema.Prog_TrackerMetaREV,
        schemaName: 'PG',
        tableName: 'Prog_TrackerMetaREV',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
        ],
        primaryKey: 'ID'
    },
    Prog_ROCSetREV: {
        name: 'Prog_ROCSetREV',
        table: schema.Prog_ROCSetREV,
        schemaName: 'PG',
        tableName: 'Prog_ROCSetREV',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
        ],
        primaryKey: 'ID'
    },
    Prog_FA: {
        name: 'Prog_FA',
        table: schema.Prog_FA,
        schemaName: 'PG',
        tableName: 'Prog_FA',
        kind: 'table',
        primaryKeys: [{ name: 'GUID', dataType: 'string' }],
        hasUserID: false,
        relations: [
            {
                name: 'Discipline',
                relationType: 'oneToOne',
                childTable: schema.Ref_Disciplines,
                currentTableKey: 'DisciplineID',
                childKey: 'ID'
            },
            {
                name: 'Job',
                relationType: 'oneToOne',
                childTable: schema.Jobs,
                currentTableKey: 'JobID',
                childKey: 'ID'
            },
            {
                name: 'UsersFROMLocked',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'Locked',
                childKey: 'ID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
            {
                name: 'Que',
                relationType: 'oneToOne',
                childTable: schema.Ref_Prog_Ques,
                currentTableKey: 'QueID',
                childKey: 'ID'
            },
            {
                name: 'ROC',
                relationType: 'oneToOne',
                childTable: schema.Prog_ROCs,
                currentTableKey: 'ROCID',
                childKey: 'ID'
            },
            {
                name: 'Status',
                relationType: 'oneToOne',
                childTable: schema.Ref_Prog_ActivityStatuses,
                currentTableKey: 'StatusID',
                childKey: 'ID'
            },
            {
                name: 'Submission',
                relationType: 'oneToOne',
                childTable: schema.Prog_SubmissionDetails,
                currentTableKey: 'SubmissionGUID',
                childKey: 'GUID'
            },
            {
                name: 'Tracker',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'TrackerID',
                childKey: 'ID'
            },
            {
                name: 'Prog_FAComments',
                relationType: 'oneToMany',
                childTable: schema.Prog_FAComments,
                currentTableKey: 'GUID',
                childKey: 'ActivityGUID'
            },
            {
                name: 'Prog_FAPipeSpools',
                relationType: 'oneToMany',
                childTable: schema.Prog_FAPipeSpools,
                currentTableKey: 'GUID',
                childKey: 'ActivityGUID'
            },
            {
                name: 'Prog_FAPipeWelds',
                relationType: 'oneToMany',
                childTable: schema.Prog_FAPipeWelds,
                currentTableKey: 'GUID',
                childKey: 'ActivityGUID'
            },
            {
                name: 'Prog_FAMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_FAMeta,
                currentTableKey: 'GUID',
                childKey: 'ActivityGUID'
            },
            {
                name: 'Prog_FAPaintWelds',
                relationType: 'oneToMany',
                childTable: schema.Prog_FAPaintWelds,
                currentTableKey: 'GUID',
                childKey: 'ActivityGUID'
            },
        ],
        primaryKey: 'GUID'
    },
    Prog_ROCsREV: {
        name: 'Prog_ROCsREV',
        table: schema.Prog_ROCsREV,
        schemaName: 'PG',
        tableName: 'Prog_ROCsREV',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
        ],
        primaryKey: 'ID'
    },
    Prog_ROCs: {
        name: 'Prog_ROCs',
        table: schema.Prog_ROCs,
        schemaName: 'PG',
        tableName: 'Prog_ROCs',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_FA',
                relationType: 'oneToMany',
                childTable: schema.Prog_FA,
                currentTableKey: 'ID',
                childKey: 'ROCID'
            },
            {
                name: 'ROCSet',
                relationType: 'oneToOne',
                childTable: schema.Prog_ROCSet,
                currentTableKey: 'ROCSetID',
                childKey: 'ID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_ROCSet: {
        name: 'Prog_ROCSet',
        table: schema.Prog_ROCSet,
        schemaName: 'PG',
        tableName: 'Prog_ROCSet',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'ActivityType',
                relationType: 'oneToOne',
                childTable: schema.Ref_Prog_ActivityTypes,
                currentTableKey: 'ActivityTypeID',
                childKey: 'ID'
            },
            {
                name: 'Job',
                relationType: 'oneToOne',
                childTable: schema.Jobs,
                currentTableKey: 'JobID',
                childKey: 'ID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
            {
                name: 'Prog_ROCs',
                relationType: 'oneToMany',
                childTable: schema.Prog_ROCs,
                currentTableKey: 'ID',
                childKey: 'ROCSetID'
            },
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToMany',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'ID',
                childKey: 'ROCSetID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_BAComments: {
        name: 'Prog_BAComments',
        table: schema.Prog_BAComments,
        schemaName: 'PG',
        tableName: 'Prog_BAComments',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Activity',
                relationType: 'oneToOne',
                childTable: schema.Prog_BA,
                currentTableKey: 'ActivityGUID',
                childKey: 'GUID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_FAMeta: {
        name: 'Prog_FAMeta',
        table: schema.Prog_FAMeta,
        schemaName: 'PG',
        tableName: 'Prog_FAMeta',
        kind: 'table',
        primaryKeys: [{ name: 'ActivityGUID', dataType: 'string' }],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_FA',
                relationType: 'oneToOne',
                childTable: schema.Prog_FA,
                currentTableKey: 'ActivityGUID',
                childKey: 'GUID'
            },
            {
                name: 'BA',
                relationType: 'oneToOne',
                childTable: schema.Prog_BA,
                currentTableKey: 'BAGUID',
                childKey: 'GUID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ActivityGUID'
    },
    Prog_FAPaintWelds: {
        name: 'Prog_FAPaintWelds',
        table: schema.Prog_FAPaintWelds,
        schemaName: 'PG',
        tableName: 'Prog_FAPaintWelds',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Activity',
                relationType: 'oneToOne',
                childTable: schema.Prog_FA,
                currentTableKey: 'ActivityGUID',
                childKey: 'GUID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerMeta: {
        name: 'Prog_TrackerMeta',
        table: schema.Prog_TrackerMeta,
        schemaName: 'PG',
        tableName: 'Prog_TrackerMeta',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'ActivityType',
                relationType: 'oneToOne',
                childTable: schema.Ref_Prog_ActivityTypes,
                currentTableKey: 'ActivityTypeID',
                childKey: 'ID'
            },
            {
                name: 'Contractor',
                relationType: 'oneToOne',
                childTable: schema.Contractors,
                currentTableKey: 'ContractorID',
                childKey: 'ID'
            },
            {
                name: 'Discipline',
                relationType: 'oneToOne',
                childTable: schema.Ref_Disciplines,
                currentTableKey: 'DisciplineID',
                childKey: 'ID'
            },
            {
                name: 'Job',
                relationType: 'oneToOne',
                childTable: schema.Jobs,
                currentTableKey: 'JobID',
                childKey: 'ID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
            {
                name: 'ROCSet',
                relationType: 'oneToOne',
                childTable: schema.Prog_ROCSet,
                currentTableKey: 'ROCSetID',
                childKey: 'ID'
            },
            {
                name: 'Prog_TrackerSpecsCivil',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerSpecsCivil,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
            {
                name: 'Prog_TrackerSpecsPipe',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerSpecsPipe,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
            {
                name: 'Prog_TrackerSpecsElectCable',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerSpecsElectCable,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
            {
                name: 'Prog_TrackerSpecsElectInst',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerSpecsElectInst,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
            {
                name: 'Prog_TrackerSpecsElectTray',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerSpecsElectTray,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
            {
                name: 'Prog_TrackerSpecsElectGeneral',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerSpecsElectGeneral,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
            {
                name: 'Prog_TrackerSpecsInsulation',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerSpecsInsulation,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
            {
                name: 'Prog_TrackerSpecsTAR',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerSpecsTAR,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
            {
                name: 'Prog_TrackerSpecsElectConduit',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerSpecsElectConduit,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
            {
                name: 'Prog_FA',
                relationType: 'oneToMany',
                childTable: schema.Prog_FA,
                currentTableKey: 'ID',
                childKey: 'TrackerID'
            },
            {
                name: 'Prog_TrackerSpecsFireproof',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerSpecsFireproof,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
            {
                name: 'Prog_TrackerSpecsPaint',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerSpecsPaint,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
            {
                name: 'Prog_TrackerSpecsEquip',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerSpecsEquip,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
            {
                name: 'Prog_TrackerSpecsSteel',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerSpecsSteel,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
            {
                name: 'Prog_TrackerSpecsTraceElect',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerSpecsTraceElect,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
            {
                name: 'Prog_TrackerCalcsCivil_View',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerCalcsCivil_View,
                currentTableKey: 'ID',
                childKey: 'ID',
                isView: true
            },
            {
                name: 'Prog_TrackerCalcsElectConduit_View',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerCalcsElectConduit_View,
                currentTableKey: 'ID',
                childKey: 'ID',
                isView: true
            },
            {
                name: 'Prog_TrackerCalcsElectGeneral_View',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerCalcsElectGeneral_View,
                currentTableKey: 'ID',
                childKey: 'ID',
                isView: true
            },
            {
                name: 'Prog_TrackerCalcsElectInst_View',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerCalcsElectInst_View,
                currentTableKey: 'ID',
                childKey: 'ID',
                isView: true
            },
            {
                name: 'Prog_TrackerCalcsTraceElect_View',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerCalcsTraceElect_View,
                currentTableKey: 'ID',
                childKey: 'ID',
                isView: true
            },
            {
                name: 'Prog_TrackerCalcsElectTray_View',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerCalcsElectTray_View,
                currentTableKey: 'ID',
                childKey: 'ID',
                isView: true
            },
            {
                name: 'Prog_TrackerCalcsEquip_View',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerCalcsEquip_View,
                currentTableKey: 'ID',
                childKey: 'ID',
                isView: true
            },
            {
                name: 'Prog_TrackerCalcsInsulation_View',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerCalcsInsulation_View,
                currentTableKey: 'ID',
                childKey: 'ID',
                isView: true
            },
            {
                name: 'Prog_TrackerCalcsPipe_View',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerCalcsPipe_View,
                currentTableKey: 'ID',
                childKey: 'ID',
                isView: true
            },
            {
                name: 'Prog_TrackerCalcsSteel_View',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerCalcsSteel_View,
                currentTableKey: 'ID',
                childKey: 'ID',
                isView: true
            },
            {
                name: 'Prog_TrackerCalcsTAR_View',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerCalcsTAR_View,
                currentTableKey: 'ID',
                childKey: 'ID',
                isView: true
            },
            {
                name: 'Prog_TrackerCalcsPaint_View',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerCalcsPaint_View,
                currentTableKey: 'ID',
                childKey: 'ID',
                isView: true
            },
            {
                name: 'Prog_TrackerCalcsElectCable_View',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerCalcsElectCable_View,
                currentTableKey: 'ID',
                childKey: 'ID',
                isView: true
            },
            {
                name: 'Prog_TrackerCalcsALL_View',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerCalcsALL_View,
                currentTableKey: 'ID',
                childKey: 'ID',
                isView: true
            },
            {
                name: 'Prog_TrackerCalcsFireproof_View',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerCalcsFireproof_View,
                currentTableKey: 'ID',
                childKey: 'ID',
                isView: true
            },
            {
                name: 'Prog_FASAEarnedALL_View',
                relationType: 'oneToOne',
                childTable: schema.Prog_FASAEarnedALL_View,
                currentTableKey: 'ID',
                childKey: 'TrackerID',
                isView: true
            },
            {
                name: 'Prog_FASAEarnedCivil_View',
                relationType: 'oneToOne',
                childTable: schema.Prog_FASAEarnedCivil_View,
                currentTableKey: 'ID',
                childKey: 'TrackerID',
                isView: true
            },
            {
                name: 'Prog_FASAEarnedElectCable_View',
                relationType: 'oneToOne',
                childTable: schema.Prog_FASAEarnedElectCable_View,
                currentTableKey: 'ID',
                childKey: 'TrackerID',
                isView: true
            },
            {
                name: 'Prog_FASAEarnedElectConduit_View',
                relationType: 'oneToOne',
                childTable: schema.Prog_FASAEarnedElectConduit_View,
                currentTableKey: 'ID',
                childKey: 'TrackerID',
                isView: true
            },
            {
                name: 'Prog_FASAEarnedElectGeneral_View',
                relationType: 'oneToOne',
                childTable: schema.Prog_FASAEarnedElectGeneral_View,
                currentTableKey: 'ID',
                childKey: 'TrackerID',
                isView: true
            },
            {
                name: 'Prog_FASAEarnedElectInst_View',
                relationType: 'oneToOne',
                childTable: schema.Prog_FASAEarnedElectInst_View,
                currentTableKey: 'ID',
                childKey: 'TrackerID',
                isView: true
            },
            {
                name: 'Prog_FASAEarnedTraceElect_View',
                relationType: 'oneToOne',
                childTable: schema.Prog_FASAEarnedTraceElect_View,
                currentTableKey: 'ID',
                childKey: 'TrackerID',
                isView: true
            },
            {
                name: 'Prog_FASAEarnedElectTray_View',
                relationType: 'oneToOne',
                childTable: schema.Prog_FASAEarnedElectTray_View,
                currentTableKey: 'ID',
                childKey: 'TrackerID',
                isView: true
            },
            {
                name: 'Prog_FASAEarnedEquip_View',
                relationType: 'oneToOne',
                childTable: schema.Prog_FASAEarnedEquip_View,
                currentTableKey: 'ID',
                childKey: 'TrackerID',
                isView: true
            },
            {
                name: 'Prog_FASAEarnedFireproof_View',
                relationType: 'oneToOne',
                childTable: schema.Prog_FASAEarnedFireproof_View,
                currentTableKey: 'ID',
                childKey: 'TrackerID',
                isView: true
            },
            {
                name: 'Prog_FASAEarnedInsulation_View',
                relationType: 'oneToOne',
                childTable: schema.Prog_FASAEarnedInsulation_View,
                currentTableKey: 'ID',
                childKey: 'TrackerID',
                isView: true
            },
            {
                name: 'Prog_FASAEarnedPaint_View',
                relationType: 'oneToOne',
                childTable: schema.Prog_FASAEarnedPaint_View,
                currentTableKey: 'ID',
                childKey: 'TrackerID',
                isView: true
            },
            {
                name: 'Prog_FASAEarnedPipe_View',
                relationType: 'oneToOne',
                childTable: schema.Prog_FASAEarnedPipe_View,
                currentTableKey: 'ID',
                childKey: 'TrackerID',
                isView: true
            },
            {
                name: 'Prog_FASAEarnedSteel_View',
                relationType: 'oneToOne',
                childTable: schema.Prog_FASAEarnedSteel_View,
                currentTableKey: 'ID',
                childKey: 'TrackerID',
                isView: true
            },
            {
                name: 'Prog_FASAEarnedTAR_View',
                relationType: 'oneToOne',
                childTable: schema.Prog_FASAEarnedTAR_View,
                currentTableKey: 'ID',
                childKey: 'TrackerID',
                isView: true
            },
        ],
        primaryKey: 'ID'
    },
    Landing_TrackerFireproof: {
        name: 'Landing_TrackerFireproof',
        table: schema.Landing_TrackerFireproof,
        schemaName: 'PG',
        tableName: 'Landing_TrackerFireproof',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Job',
                relationType: 'oneToOne',
                childTable: schema.Jobs,
                currentTableKey: 'JobID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Landing_TrackerPaint: {
        name: 'Landing_TrackerPaint',
        table: schema.Landing_TrackerPaint,
        schemaName: 'PG',
        tableName: 'Landing_TrackerPaint',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Job',
                relationType: 'oneToOne',
                childTable: schema.Jobs,
                currentTableKey: 'JobID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerSpecsFireproof: {
        name: 'Prog_TrackerSpecsFireproof',
        table: schema.Prog_TrackerSpecsFireproof,
        schemaName: 'PG',
        tableName: 'Prog_TrackerSpecsFireproof',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerSpecsFireproofREV: {
        name: 'Prog_TrackerSpecsFireproofREV',
        table: schema.Prog_TrackerSpecsFireproofREV,
        schemaName: 'PG',
        tableName: 'Prog_TrackerSpecsFireproofREV',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerSpecsPaint: {
        name: 'Prog_TrackerSpecsPaint',
        table: schema.Prog_TrackerSpecsPaint,
        schemaName: 'PG',
        tableName: 'Prog_TrackerSpecsPaint',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerSpecsPaintREV: {
        name: 'Prog_TrackerSpecsPaintREV',
        table: schema.Prog_TrackerSpecsPaintREV,
        schemaName: 'PG',
        tableName: 'Prog_TrackerSpecsPaintREV',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
        ],
        primaryKey: 'ID'
    },
    Landing_TrackerSteel: {
        name: 'Landing_TrackerSteel',
        table: schema.Landing_TrackerSteel,
        schemaName: 'PG',
        tableName: 'Landing_TrackerSteel',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Job',
                relationType: 'oneToOne',
                childTable: schema.Jobs,
                currentTableKey: 'JobID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Landing_TrackerEquip: {
        name: 'Landing_TrackerEquip',
        table: schema.Landing_TrackerEquip,
        schemaName: 'PG',
        tableName: 'Landing_TrackerEquip',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Job',
                relationType: 'oneToOne',
                childTable: schema.Jobs,
                currentTableKey: 'JobID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerSpecsEquip: {
        name: 'Prog_TrackerSpecsEquip',
        table: schema.Prog_TrackerSpecsEquip,
        schemaName: 'PG',
        tableName: 'Prog_TrackerSpecsEquip',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerSpecsEquipREV: {
        name: 'Prog_TrackerSpecsEquipREV',
        table: schema.Prog_TrackerSpecsEquipREV,
        schemaName: 'PG',
        tableName: 'Prog_TrackerSpecsEquipREV',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerSpecsSteel: {
        name: 'Prog_TrackerSpecsSteel',
        table: schema.Prog_TrackerSpecsSteel,
        schemaName: 'PG',
        tableName: 'Prog_TrackerSpecsSteel',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerSpecsSteelREV: {
        name: 'Prog_TrackerSpecsSteelREV',
        table: schema.Prog_TrackerSpecsSteelREV,
        schemaName: 'PG',
        tableName: 'Prog_TrackerSpecsSteelREV',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
        ],
        primaryKey: 'ID'
    },
    Prog_BA: {
        name: 'Prog_BA',
        table: schema.Prog_BA,
        schemaName: 'PG',
        tableName: 'Prog_BA',
        kind: 'table',
        primaryKeys: [{ name: 'GUID', dataType: 'string' }],
        hasUserID: false,
        relations: [
            {
                name: 'Discipline',
                relationType: 'oneToOne',
                childTable: schema.Ref_Disciplines,
                currentTableKey: 'DisciplineID',
                childKey: 'ID'
            },
            {
                name: 'Job',
                relationType: 'oneToOne',
                childTable: schema.Jobs,
                currentTableKey: 'JobID',
                childKey: 'ID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
            {
                name: 'Que',
                relationType: 'oneToOne',
                childTable: schema.Ref_Prog_Ques,
                currentTableKey: 'QueID',
                childKey: 'ID'
            },
            {
                name: 'Status',
                relationType: 'oneToOne',
                childTable: schema.Ref_Prog_ActivityStatuses,
                currentTableKey: 'StatusID',
                childKey: 'ID'
            },
            {
                name: 'Submission',
                relationType: 'oneToOne',
                childTable: schema.Prog_SubmissionDetails,
                currentTableKey: 'SubmissionGUID',
                childKey: 'GUID'
            },
            {
                name: 'Prog_BAComments',
                relationType: 'oneToMany',
                childTable: schema.Prog_BAComments,
                currentTableKey: 'GUID',
                childKey: 'ActivityGUID'
            },
            {
                name: 'Prog_FAMeta',
                relationType: 'oneToMany',
                childTable: schema.Prog_FAMeta,
                currentTableKey: 'GUID',
                childKey: 'BAGUID'
            },
        ],
        primaryKey: 'GUID'
    },
    Prog_BAREV: {
        name: 'Prog_BAREV',
        table: schema.Prog_BAREV,
        schemaName: 'PG',
        tableName: 'Prog_BAREV',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
        ],
        primaryKey: 'ID'
    },
    Landing_TrackerTraceElect: {
        name: 'Landing_TrackerTraceElect',
        table: schema.Landing_TrackerTraceElect,
        schemaName: 'PG',
        tableName: 'Landing_TrackerTraceElect',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Job',
                relationType: 'oneToOne',
                childTable: schema.Jobs,
                currentTableKey: 'JobID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerSpecsTraceElect: {
        name: 'Prog_TrackerSpecsTraceElect',
        table: schema.Prog_TrackerSpecsTraceElect,
        schemaName: 'PG',
        tableName: 'Prog_TrackerSpecsTraceElect',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
            {
                name: 'UsersFROMModifiedBy',
                relationType: 'oneToOne',
                childTable: schema.Users,
                currentTableKey: 'ModifiedBy',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerSpecsTraceElectREV: {
        name: 'Prog_TrackerSpecsTraceElectREV',
        table: schema.Prog_TrackerSpecsTraceElectREV,
        schemaName: 'PG',
        tableName: 'Prog_TrackerSpecsTraceElectREV',
        kind: 'table',
        primaryKeys: [{ name: 'ID', dataType: 'number' }],
        hasUserID: false,
        relations: [
        ],
        primaryKey: 'ID'
    },
    Prog_FASAEarnedALL_View: {
        name: 'Prog_FASAEarnedALL_View',
        table: schema.Prog_FASAEarnedALL_View,
        schemaName: 'PG',
        tableName: 'Prog_FASAEarnedALL_View',
        kind: 'view',
        primaryKeys: [],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'TrackerID',
                childKey: 'ID',
                isView: true
            },
        ],
        primaryKey: 'TrackerID'
    },
    Prog_FASAEarnedCivil_View: {
        name: 'Prog_FASAEarnedCivil_View',
        table: schema.Prog_FASAEarnedCivil_View,
        schemaName: 'PG',
        tableName: 'Prog_FASAEarnedCivil_View',
        kind: 'view',
        primaryKeys: [],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'TrackerID',
                childKey: 'ID',
                isView: true
            },
        ],
        primaryKey: 'JobID'
    },
    Prog_FASAEarnedElectCable_View: {
        name: 'Prog_FASAEarnedElectCable_View',
        table: schema.Prog_FASAEarnedElectCable_View,
        schemaName: 'PG',
        tableName: 'Prog_FASAEarnedElectCable_View',
        kind: 'view',
        primaryKeys: [],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'TrackerID',
                childKey: 'ID',
                isView: true
            },
        ],
        primaryKey: 'JobID'
    },
    Prog_FASAEarnedElectConduit_View: {
        name: 'Prog_FASAEarnedElectConduit_View',
        table: schema.Prog_FASAEarnedElectConduit_View,
        schemaName: 'PG',
        tableName: 'Prog_FASAEarnedElectConduit_View',
        kind: 'view',
        primaryKeys: [],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'TrackerID',
                childKey: 'ID',
                isView: true
            },
        ],
        primaryKey: 'JobID'
    },
    Prog_FASAEarnedElectGeneral_View: {
        name: 'Prog_FASAEarnedElectGeneral_View',
        table: schema.Prog_FASAEarnedElectGeneral_View,
        schemaName: 'PG',
        tableName: 'Prog_FASAEarnedElectGeneral_View',
        kind: 'view',
        primaryKeys: [],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'TrackerID',
                childKey: 'ID',
                isView: true
            },
        ],
        primaryKey: 'JobID'
    },
    Prog_FASAEarnedElectInst_View: {
        name: 'Prog_FASAEarnedElectInst_View',
        table: schema.Prog_FASAEarnedElectInst_View,
        schemaName: 'PG',
        tableName: 'Prog_FASAEarnedElectInst_View',
        kind: 'view',
        primaryKeys: [],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'TrackerID',
                childKey: 'ID',
                isView: true
            },
        ],
        primaryKey: 'JobID'
    },
    Prog_FASAEarnedElectTrace_View: {
        name: 'Prog_FASAEarnedElectTrace_View',
        table: schema.Prog_FASAEarnedElectTrace_View,
        schemaName: 'PG',
        tableName: 'Prog_FASAEarnedElectTrace_View',
        kind: 'view',
        primaryKeys: [],
        hasUserID: false,
        relations: [
        ],
        primaryKey: 'JobID'
    },
    Prog_FASAEarnedElectTray_View: {
        name: 'Prog_FASAEarnedElectTray_View',
        table: schema.Prog_FASAEarnedElectTray_View,
        schemaName: 'PG',
        tableName: 'Prog_FASAEarnedElectTray_View',
        kind: 'view',
        primaryKeys: [],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'TrackerID',
                childKey: 'ID',
                isView: true
            },
        ],
        primaryKey: 'JobID'
    },
    Prog_FASAEarnedEquip_View: {
        name: 'Prog_FASAEarnedEquip_View',
        table: schema.Prog_FASAEarnedEquip_View,
        schemaName: 'PG',
        tableName: 'Prog_FASAEarnedEquip_View',
        kind: 'view',
        primaryKeys: [],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'TrackerID',
                childKey: 'ID',
                isView: true
            },
        ],
        primaryKey: 'JobID'
    },
    Prog_FASAEarnedFireproof_View: {
        name: 'Prog_FASAEarnedFireproof_View',
        table: schema.Prog_FASAEarnedFireproof_View,
        schemaName: 'PG',
        tableName: 'Prog_FASAEarnedFireproof_View',
        kind: 'view',
        primaryKeys: [],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'TrackerID',
                childKey: 'ID',
                isView: true
            },
        ],
        primaryKey: 'JobID'
    },
    Prog_FASAEarnedInsulation_View: {
        name: 'Prog_FASAEarnedInsulation_View',
        table: schema.Prog_FASAEarnedInsulation_View,
        schemaName: 'PG',
        tableName: 'Prog_FASAEarnedInsulation_View',
        kind: 'view',
        primaryKeys: [],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'TrackerID',
                childKey: 'ID',
                isView: true
            },
        ],
        primaryKey: 'JobID'
    },
    Prog_FASAEarnedPaint_View: {
        name: 'Prog_FASAEarnedPaint_View',
        table: schema.Prog_FASAEarnedPaint_View,
        schemaName: 'PG',
        tableName: 'Prog_FASAEarnedPaint_View',
        kind: 'view',
        primaryKeys: [],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'TrackerID',
                childKey: 'ID',
                isView: true
            },
        ],
        primaryKey: 'JobID'
    },
    Prog_FASAEarnedPipe_View: {
        name: 'Prog_FASAEarnedPipe_View',
        table: schema.Prog_FASAEarnedPipe_View,
        schemaName: 'PG',
        tableName: 'Prog_FASAEarnedPipe_View',
        kind: 'view',
        primaryKeys: [],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'TrackerID',
                childKey: 'ID',
                isView: true
            },
        ],
        primaryKey: 'JobID'
    },
    Prog_FASAEarnedSteel_View: {
        name: 'Prog_FASAEarnedSteel_View',
        table: schema.Prog_FASAEarnedSteel_View,
        schemaName: 'PG',
        tableName: 'Prog_FASAEarnedSteel_View',
        kind: 'view',
        primaryKeys: [],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'TrackerID',
                childKey: 'ID',
                isView: true
            },
        ],
        primaryKey: 'JobID'
    },
    Prog_FASAEarnedTAR_View: {
        name: 'Prog_FASAEarnedTAR_View',
        table: schema.Prog_FASAEarnedTAR_View,
        schemaName: 'PG',
        tableName: 'Prog_FASAEarnedTAR_View',
        kind: 'view',
        primaryKeys: [],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'TrackerID',
                childKey: 'ID',
                isView: true
            },
        ],
        primaryKey: 'JobID'
    },
    Prog_FASAEarnedTraceElect_View: {
        name: 'Prog_FASAEarnedTraceElect_View',
        table: schema.Prog_FASAEarnedTraceElect_View,
        schemaName: 'PG',
        tableName: 'Prog_FASAEarnedTraceElect_View',
        kind: 'view',
        primaryKeys: [],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'TrackerID',
                childKey: 'ID',
                isView: true
            },
        ],
        primaryKey: 'JobID'
    },
    Prog_PF_View: {
        name: 'Prog_PF_View',
        table: schema.Prog_PF_View,
        schemaName: 'PG',
        tableName: 'Prog_PF_View',
        kind: 'view',
        primaryKeys: [],
        hasUserID: false,
        relations: [
        ],
        primaryKey: 'ShiftDate'
    },
    Prog_TrackerCalcsALL_View: {
        name: 'Prog_TrackerCalcsALL_View',
        table: schema.Prog_TrackerCalcsALL_View,
        schemaName: 'PG',
        tableName: 'Prog_TrackerCalcsALL_View',
        kind: 'view',
        primaryKeys: [],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerCalcsCivil_View: {
        name: 'Prog_TrackerCalcsCivil_View',
        table: schema.Prog_TrackerCalcsCivil_View,
        schemaName: 'PG',
        tableName: 'Prog_TrackerCalcsCivil_View',
        kind: 'view',
        primaryKeys: [],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerCalcsElectCable_View: {
        name: 'Prog_TrackerCalcsElectCable_View',
        table: schema.Prog_TrackerCalcsElectCable_View,
        schemaName: 'PG',
        tableName: 'Prog_TrackerCalcsElectCable_View',
        kind: 'view',
        primaryKeys: [],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerCalcsElectConduit_View: {
        name: 'Prog_TrackerCalcsElectConduit_View',
        table: schema.Prog_TrackerCalcsElectConduit_View,
        schemaName: 'PG',
        tableName: 'Prog_TrackerCalcsElectConduit_View',
        kind: 'view',
        primaryKeys: [],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerCalcsElectGeneral_View: {
        name: 'Prog_TrackerCalcsElectGeneral_View',
        table: schema.Prog_TrackerCalcsElectGeneral_View,
        schemaName: 'PG',
        tableName: 'Prog_TrackerCalcsElectGeneral_View',
        kind: 'view',
        primaryKeys: [],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerCalcsElectInst_View: {
        name: 'Prog_TrackerCalcsElectInst_View',
        table: schema.Prog_TrackerCalcsElectInst_View,
        schemaName: 'PG',
        tableName: 'Prog_TrackerCalcsElectInst_View',
        kind: 'view',
        primaryKeys: [],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerCalcsElectTrace_View: {
        name: 'Prog_TrackerCalcsElectTrace_View',
        table: schema.Prog_TrackerCalcsElectTrace_View,
        schemaName: 'PG',
        tableName: 'Prog_TrackerCalcsElectTrace_View',
        kind: 'view',
        primaryKeys: [],
        hasUserID: false,
        relations: [
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerCalcsElectTray_View: {
        name: 'Prog_TrackerCalcsElectTray_View',
        table: schema.Prog_TrackerCalcsElectTray_View,
        schemaName: 'PG',
        tableName: 'Prog_TrackerCalcsElectTray_View',
        kind: 'view',
        primaryKeys: [],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerCalcsEquip_View: {
        name: 'Prog_TrackerCalcsEquip_View',
        table: schema.Prog_TrackerCalcsEquip_View,
        schemaName: 'PG',
        tableName: 'Prog_TrackerCalcsEquip_View',
        kind: 'view',
        primaryKeys: [],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerCalcsFireproof_View: {
        name: 'Prog_TrackerCalcsFireproof_View',
        table: schema.Prog_TrackerCalcsFireproof_View,
        schemaName: 'PG',
        tableName: 'Prog_TrackerCalcsFireproof_View',
        kind: 'view',
        primaryKeys: [],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerCalcsInsulation_View: {
        name: 'Prog_TrackerCalcsInsulation_View',
        table: schema.Prog_TrackerCalcsInsulation_View,
        schemaName: 'PG',
        tableName: 'Prog_TrackerCalcsInsulation_View',
        kind: 'view',
        primaryKeys: [],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerCalcsPaint_View: {
        name: 'Prog_TrackerCalcsPaint_View',
        table: schema.Prog_TrackerCalcsPaint_View,
        schemaName: 'PG',
        tableName: 'Prog_TrackerCalcsPaint_View',
        kind: 'view',
        primaryKeys: [],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerCalcsPipe_View: {
        name: 'Prog_TrackerCalcsPipe_View',
        table: schema.Prog_TrackerCalcsPipe_View,
        schemaName: 'PG',
        tableName: 'Prog_TrackerCalcsPipe_View',
        kind: 'view',
        primaryKeys: [],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerCalcsSteel_View: {
        name: 'Prog_TrackerCalcsSteel_View',
        table: schema.Prog_TrackerCalcsSteel_View,
        schemaName: 'PG',
        tableName: 'Prog_TrackerCalcsSteel_View',
        kind: 'view',
        primaryKeys: [],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerCalcsTAR_View: {
        name: 'Prog_TrackerCalcsTAR_View',
        table: schema.Prog_TrackerCalcsTAR_View,
        schemaName: 'PG',
        tableName: 'Prog_TrackerCalcsTAR_View',
        kind: 'view',
        primaryKeys: [],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
    Prog_TrackerCalcsTraceElect_View: {
        name: 'Prog_TrackerCalcsTraceElect_View',
        table: schema.Prog_TrackerCalcsTraceElect_View,
        schemaName: 'PG',
        tableName: 'Prog_TrackerCalcsTraceElect_View',
        kind: 'view',
        primaryKeys: [],
        hasUserID: false,
        relations: [
            {
                name: 'Prog_TrackerMeta',
                relationType: 'oneToOne',
                childTable: schema.Prog_TrackerMeta,
                currentTableKey: 'ID',
                childKey: 'ID'
            },
        ],
        primaryKey: 'ID'
    },
};